import React from 'react';
import PropTypes from 'prop-types';

import CtaLink from 'components/essentials/Cta/CtaLink';
import CtaButton from 'components/essentials/Cta/CtaButton';

const SubmitPhotosUploaded = ({ onSubmitAnotherPhotoClick }) => (
  <div>
    <h2 className="text-2xl font-bold text-gray text-center mt-0 mx-0 mb-4 md:mt-8">
      Your photo has been received and is now in review!
    </h2>

    <div className="text-base mx-0 my-4 md:mb-12">
      We will email you to let you know when your photo has been approved and is
      live on our&nbsp;
      <CtaLink
        to="/customer-photos/"
        color="brand"
        noLinkPadding
        hasArrow={false}
        textClassName="!lowercase"
      >
        Inspiration
      </CtaLink>
      &nbsp;page! As soon as it’s approved, you’ll see an email from us with
      details on how to redeem your $25 gift card.
    </div>

    <div className="flex justify-center">
      <CtaButton
        color="brand"
        noLinkPadding
        hasArrow={false}
        styling="outline-button"
        onClick={onSubmitAnotherPhotoClick}
        textClassName="!lowercase"
      >
        Submit Another Photo
      </CtaButton>
    </div>
  </div>
);

SubmitPhotosUploaded.propTypes = {
  onSubmitAnotherPhotoClick: PropTypes.func,
};

export default SubmitPhotosUploaded;
